// extracted by mini-css-extract-plugin
module.exports = {"lds-facebook":"Loader_lds-facebook__3M-wt"};